export default "__VITE_ASSET__f54ef076__"